<template>
  
    <div class="vertical-menu">

        <div data-simplebar class="h-100">

            <!--- Sidemenu -->
            <div id="sidebar-menu">
                <!-- Left Menu Start -->
                <ul class="metismenu list-unstyled" id="side-menu">
                    <li class="menu-title">Menu</li>

                    <li>
                        <a href="https://app.seigrupo.com.mx/inicio" class="waves-effect">
                            <i class="mdi mdi-home-variant-outline"></i>
                            <!--<span
                                class="badge rounded-pill bg-primary float-end">3</span>-->
                                <router-link  to="/inicio" >Dashboard</router-link> 
                        </a>
                    </li>
                    <li>
                      <a class=" waves-effect">
                        <i class="mdi mdi-account-circle"></i>
                        <router-link  to="/cotizacion" ><span>Cotizacion</span></router-link> 
                          
                      </a>
                    </li>
                    
                    <li>
                      <a  class=" waves-effect">
                          <i class="mdi mdi-clipboard-check"></i>
                          <router-link  to="/detallesolicitud" ><span>Solicitudes</span></router-link>
                      </a>
                    </li>
                    <li>
                      <a  class=" waves-effect">
                          <i class="mdi mdi-account-search"></i>
                          <router-link  to="/detalleinspeccion" ><span>Inspecciones</span></router-link>
                      </a>
                    </li>
                    <li>
                      <a class=" waves-effect">
                        <i class="mdi mdi-account-circle"></i>
                        <router-link  to="/usuarios" ><span>Usuarios</span></router-link> 
                          
                      </a>
                    </li>
                    
                    <!--<li>
                        <a href="javascript: void(0);" class="has-arrow waves-effect">
                            <i class="mdi mdi-email-outline"></i>
                            <span>Email</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li><a href="email-inbox.html">Inbox</a></li>
                            <li><a href="email-read.html">Read Email</a></li>
                            <li><a href="email-compose.html">Email Compose</a></li>
                        </ul>
                    </li>

                    <li class="menu-title">Layouts</li>

                    <li>
                        <a href="javascript: void(0);" class="has-arrow waves-effect">
                            <i class="mdi mdi-gradient"></i>
                            <span>Vertical</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li><a href="layouts-light-sidebar.html">Light Sidebar</a></li>
                            <li><a href="layouts-compact-sidebar.html">Compact Sidebar</a></li>
                            <li><a href="layouts-icon-sidebar.html">Icon Sidebar</a></li>
                            <li><a href="layouts-boxed.html">Boxed Layout</a></li>
                        </ul>
                    </li>

                    <li>
                        <a href="javascript: void(0);" class="has-arrow waves-effect">
                            <i class="mdi mdi-page-layout-header"></i>
                            <span>Horizontal</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li><a href="layouts-horizontal.html">Default</a></li>
                            <li><a href="layouts-hori-topbar-dark.html">Topbar Dark</a></li>
                            <li><a href="layouts-hori-boxed-width.html">Boxed width</a></li>
                        </ul>
                    </li>

                    <li class="menu-title">Pages</li>

                    <li>
                        <a href="javascript: void(0);" class="has-arrow waves-effect">
                            <i class="mdi mdi-account-circle-outline"></i>
                            <span>Authentication</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li><a href="auth-login.html">Login</a></li>
                            <li><a href="auth-register.html">Register</a></li>
                            <li><a href="auth-recoverpw.html">Recover Password</a></li>
                            <li><a href="auth-lock-screen.html">Lock Screen</a></li>
                        </ul>
                    </li>

                    <li>
                        <a href="javascript: void(0);" class="has-arrow waves-effect">
                            <i class="mdi mdi-format-page-break"></i>
                            <span>Utility</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li><a href="pages-starter.html">Starter Page</a></li>
                            <li><a href="pages-maintenance.html">Maintenance</a></li>
                            <li><a href="pages-comingsoon.html">Coming Soon</a></li>
                            <li><a href="pages-timeline.html">Timeline</a></li>
                            <li><a href="pages-faqs.html">FAQs</a></li>
                            <li><a href="pages-pricing.html">Pricing</a></li>
                            <li><a href="pages-404.html">Error 404</a></li>
                            <li><a href="pages-500.html">Error 500</a></li>
                        </ul>
                    </li>

                    <li class="menu-title">Components</li>

                    <li>
                        <a href="javascript: void(0);" class="has-arrow waves-effect">
                            <i class="mdi mdi-briefcase-variant-outline"></i>
                            <span>UI Elements</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li><a href="ui-alerts.html">Alerts</a></li>
                            <li><a href="ui-badge.html">Badge</a></li>
                            <li><a href="ui-breadcrumb.html">Breadcrumb</a></li>
                            <li><a href="ui-buttons.html">Buttons</a></li>
                            <li><a href="ui-cards.html">Cards</a></li>
                            <li><a href="ui-carousel.html">Carousel</a></li>
                            <li><a href="ui-dropdowns.html">Dropdowns</a></li>
                            <li><a href="ui-grid.html">Grid</a></li>
                            <li><a href="ui-images.html">Images</a></li>
                            <li><a href="ui-lightbox.html">Lightbox</a></li>
                            <li><a href="ui-modals.html">Modals</a></li>
                            <li><a href="ui-offcanvas.html">Offcanvas</a></li>
                            <li><a href="ui-rangeslider.html">Range Slider</a></li>
                            <li><a href="ui-session-timeout.html">Session Timeout</a></li>
                            <li><a href="ui-pagination.html">Pagination</a></li>
                            <li><a href="ui-progressbars.html">Progress Bars</a></li>
                            <li><a href="ui-placeholders.html">Placeholders</a></li>
                            <li><a href="ui-sweet-alert.html">Sweetalert 2</a></li>
                            <li><a href="ui-tabs-accordions.html">Tabs & Accordions</a></li>
                            <li><a href="ui-typography.html">Typography</a></li>
                            <li><a href="ui-toasts.html">Toasts</a></li>
                            <li><a href="ui-video.html">Video</a></li>
                            <li><a href="ui-popover-tooltips.html">Popovers &amp; Tooltips</a></li>
                            <li><a href="ui-rating.html">Rating</a></li>
                        </ul>
                    </li>

                    <li>
                        <a href="javascript: void(0);" class="waves-effect">
                            <i class="ri-eraser-fill"></i>
                            <span class="badge rounded-pill bg-danger float-end">8</span>
                            <span>Forms</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li><a href="form-elements.html">Form Elements</a></li>
                            <li><a href="form-validation.html">Form Validation</a></li>
                            <li><a href="form-advanced.html">Form Advanced Plugins</a></li>
                            <li><a href="form-editors.html">Form Editors</a></li>
                            <li><a href="form-uploads.html">Form File Upload</a></li>
                            <li><a href="form-xeditable.html">Form X-editable</a></li>
                            <li><a href="form-wizard.html">Form Wizard</a></li>
                            <li><a href="form-mask.html">Form Mask</a></li>
                        </ul>
                    </li>

                    <li>
                        <a href="javascript: void(0);" class="has-arrow waves-effect">
                            <i class="ri-table-2"></i>
                            <span>Tables</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li><a href="tables-basic.html">Basic Tables</a></li>
                            <li><a href="tables-datatable.html">Data Tables</a></li>
                            <li><a href="tables-responsive.html">Responsive Table</a></li>
                            <li><a href="tables-editable.html">Editable Table</a></li>
                        </ul>
                    </li>

                    <li>
                        <a href="javascript: void(0);" class="has-arrow waves-effect">
                            <i class="ri-bar-chart-line"></i>
                            <span>Charts</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li><a href="charts-apex.html">Apex Charts</a></li>
                            <li><a href="charts-chartjs.html">Chartjs Charts</a></li>
                            <li><a href="charts-flot.html">Flot Charts</a></li>
                            <li><a href="charts-knob.html">Jquery Knob Charts</a></li>
                            <li><a href="charts-sparkline.html">Sparkline Charts</a></li>
                        </ul>
                    </li>

                    <li>
                        <a href="javascript: void(0);" class="has-arrow waves-effect">
                            <i class="ri-brush-line"></i>
                            <span>Icons</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li><a href="icons-remix.html">Remix Icons</a></li>
                            <li><a href="icons-materialdesign.html">Material Design</a></li>
                            <li><a href="icons-dripicons.html">Dripicons</a></li>
                            <li><a href="icons-fontawesome.html">Font Awesome </a></li>
                        </ul>
                    </li>

                    <li>
                        <a href="javascript: void(0);" class="has-arrow waves-effect">
                            <i class="ri-map-pin-line"></i>
                            <span>Maps</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="false">
                            <li><a href="maps-google.html">Google Maps</a></li>
                            <li><a href="maps-vector.html">Vector Maps</a></li>
                        </ul>
                    </li>

                    <li>
                        <a href="javascript: void(0);" class="has-arrow waves-effect">
                            <i class="ri-share-line"></i>
                            <span>Multi Level</span>
                        </a>
                        <ul class="sub-menu" aria-expanded="true">
                            <li><a href="javascript: void(0);">Level 1.1</a></li>
                            <li><a href="javascript: void(0);" class="has-arrow">Level 1.2</a>
                                <ul class="sub-menu" aria-expanded="true">
                                    <li><a href="javascript: void(0);">Level 2.1</a></li>
                                    <li><a href="javascript: void(0);">Level 2.2</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>-->
                </ul>
            </div>
            <!-- Sidebar -->
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "MenuComponent",
    mounted() {
      this.initializeMenu();
    },
    methods: {
      initializeMenu() {
        // Copia aquí el código de inicialización del menú desde app.js
        // Modifica las partes que manipulan el DOM directamente para que se ejecuten después de que Vue haya montado el componente
        (function(n) {
          "use strict";
  
          function s() {
            for (var e = document.getElementById("topnav-menu-content").getElementsByTagName("a"),
                t = 0, n = e.length; t < n; t++) {
              if ("nav-item dropdown active" === e[t].parentElement.getAttribute("class")) {
                e[t].parentElement.classList.remove("active");
                e[t].nextElementSibling.classList.remove("show");
              }
            }
          }
  
          function t(e) {
            if (n("#light-mode-switch").prop("checked") && "light-mode-switch" === e) {
              n("html").removeAttr("dir");
              n("#dark-mode-switch").prop("checked", !1);
              n("#rtl-mode-switch").prop("checked", !1);
              n("#bootstrap-style").attr("href", "assets/css/bootstrap.min.css");
              n("#app-style").attr("href", "assets/css/app.min.css");
              sessionStorage.setItem("is_visited", "light-mode-switch");
            } else if (n("#dark-mode-switch").prop("checked") && "dark-mode-switch" === e) {
              n("html").removeAttr("dir");
              n("#light-mode-switch").prop("checked", !1);
              n("#rtl-mode-switch").prop("checked", !1);
              n("#bootstrap-style").attr("href", "assets/css/bootstrap-dark.min.css");
              n("#app-style").attr("href", "assets/css/app-dark.min.css");
              sessionStorage.setItem("is_visited", "dark-mode-switch");
            } else if (n("#rtl-mode-switch").prop("checked") && "rtl-mode-switch" === e) {
              n("#light-mode-switch").prop("checked", !1);
              n("#dark-mode-switch").prop("checked", !1);
              n("#bootstrap-style").attr("href", "assets/css/bootstrap-rtl.min.css");
              n("#app-style").attr("href", "assets/css/app-rtl.min.css");
              n("html").attr("dir", "rtl");
              sessionStorage.setItem("is_visited", "rtl-mode-switch");
            }
          }
  
          function e() {
            if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
              n("body").removeClass("fullscreen-enable");
            }
          }
  
          n("#side-menu").metisMenu();
          n("#vertical-menu-btn").on("click", function(e) {
            e.preventDefault();
            n("body").toggleClass("sidebar-enable");
            if (n(window).width() >= 992) {
              n("body").toggleClass("vertical-collpsed");
            } else {
              n("body").removeClass("vertical-collpsed");
            }
          });
          n("body,html").click(function(e) {
            var t = n("#vertical-menu-btn");
            if (!t.is(e.target) && t.has(e.target).length === 0 && !e.target.closest("div.vertical-menu")) {
              n("body").removeClass("sidebar-enable");
            }
          });
          n("#sidebar-menu a").each(function() {
            var e = window.location.href.split(/[?#]/)[0];
            if (this.href == e) {
              n(this).addClass("active");
              n(this).parent().addClass("mm-active");
              n(this).parent().parent().addClass("mm-show");
              n(this).parent().parent().prev().addClass("mm-active");
              n(this).parent().parent().parent().addClass("mm-active");
              n(this).parent().parent().parent().parent().addClass("mm-show");
              n(this).parent().parent().parent().parent().parent().addClass("mm-active");
            }
          });
          n(".navbar-nav a").each(function() {
            var e = window.location.href.split(/[?#]/)[0];
            if (this.href == e) {
              n(this).addClass("active");
              n(this).parent().addClass("active");
              n(this).parent().parent().addClass("active");
              n(this).parent().parent().parent().addClass("active");
              n(this).parent().parent().parent().parent().addClass("active");
              n(this).parent().parent().parent().parent().parent().addClass("active");
            }
          });
          n(document).ready(function() {
            var e;
            if (n("#sidebar-menu").length > 0 && n("#sidebar-menu .mm-active .active").length > 0) {
              e = n("#sidebar-menu .mm-active .active").offset().top;
              if (e > 300) {
                e -= 300;
                n(".vertical-menu .simplebar-content-wrapper").animate({
                  scrollTop: e
                }, "slow");
              }
            }
          });
          n('[data-toggle="fullscreen"]').on("click", function(e) {
            e.preventDefault();
            n("body").toggleClass("fullscreen-enable");
            if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement) {
              if (document.cancelFullScreen) {
                document.cancelFullScreen();
              } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
              } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
              }
            } else {
              if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
              } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
              } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
              }
            }
          });
          document.addEventListener("fullscreenchange", e);
          document.addEventListener("webkitfullscreenchange", e);
          document.addEventListener("mozfullscreenchange", e);
          n(".right-bar-toggle").on("click", function() {
            n("body").toggleClass("right-bar-enabled");
          });
          n(document).on("click", "body", function(e) {
            if (n(e.target).closest(".right-bar-toggle, .right-bar").length === 0) {
              n("body").removeClass("right-bar-enabled");
            }
          });
          (function() {
            if (document.getElementById("topnav-menu-content")) {
              for (var e = document.getElementById("topnav-menu-content").getElementsByTagName("a"), t = 0, n = e.length; t < n; t++) {
                e[t].onclick = function(e) {
                  if ("#" === e.target.getAttribute("href")) {
                    e.target.parentElement.classList.toggle("active");
                    e.target.nextElementSibling.classList.toggle("show");
                  }
                };
              }
              window.addEventListener("resize", s);
            }
          })();
          [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]')).map(function(e) {
            return new bootstrap.Tooltip(e);
          });
          [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]')).map(function(e) {
            return new bootstrap.Popover(e);
          });
          n(window).on("load", function() {
            n("#status").fadeOut();
            n("#preloader").delay(350).fadeOut("slow");
          });
          if (window.sessionStorage) {
            var a = sessionStorage.getItem("is_visited");
            if (a) {
              n(".right-bar input:checkbox").prop("checked", !1);
              n("#" + a).prop("checked", !0);
              t(a);
            } else {
              sessionStorage.setItem("is_visited", "light-mode-switch");
            }
          }
          n("#light-mode-switch, #dark-mode-switch, #rtl-mode-switch").on("change", function(e) {
            t(e.target.id);
          });
          Waves.init();
        })(jQuery);
      }
    }
  };
  </script>
  